<template>
    <div class="container-fluid" ref="start">
        <div class="row justify-content-center flex-nowrap">
            <div class="col-1">
                <div class="sticky-top" style="top: 50%">
                    <arrow v-if="!isFrameworkCondition" direction="left" :route="getPrevPhaseRoute($route.params.routeName)" :routeName="getPrevPhaseName($route.params.routeName)"> </arrow>
                    <arrow v-else direction="left" :route="getThisPhaseRoute($route.params.routeName)" :routeName="getThisPhaseName($route.params.routeName)"> </arrow>
                </div>
            </div>
            <div class="col">
                <div class="container">
                    <div class="row">
                        <horizontal-nav :phases="phases" :activPhase="phase.Name"></horizontal-nav>                        
                    </div>
                    <div class="row">
                        <div class="col align-self-start">
                            <information-visualisation
                                :id="phase.Id"
                                :name="displayName"
                            ></information-visualisation>
                        </div>
                        <div class="col-sm-4 align-self-start">
                            <!--<score
                                :score="this.avgScores[phase.Id]"
                                :phase="'für ' + phase.Name"
                            >
                            </score>-->
                            <score
                                :value="maturityLevel"
                                :phase="'für ' + phase.Name"
                            >
                            </score>
                            <!--<card
                                title="Identifizierte Schwachstellen"
                                :text="this.weakPoints.find(point => (point.id == phase.Id)).points"
                            >
                            </card>-->
                            <card class="w-100 p-3"
                                title="Handlungsempfehlungen"
                                :text="recommendationTexts"
                                :infLetters="informationLetters"
                                :questionToRecommendationId="questionToRecommendationId"
                            >
                            </card>
                            <!--<inf-letter-card title="Steckbriefempfehlungen" :infLetters="informationLetters.find(point => (point.id == phase.Id)).letters"> </inf-letter-card>-->
                        </div>
                    </div>                  
                </div>
                <div ref="infLetter" id="infLetters">
                    <information-letter-list
                            title="Steckbriefe"
                            :informationLetters="informationLetters"
                    ></information-letter-list>
                </div>
            </div>
            <div class="col-1">
                <div class="sticky-top" style="top: 50%">
                    <arrow v-if="!isFrameworkCondition" direction="right" :route="getNextPhaseRoute($route.params.routeName)" :routeName="getNextPhaseName($route.params.routeName)"></arrow>
                    <arrow v-else direction="right" :route="getNextFrameworkPhaseRoute($route.params.routeName)" :routeName="getNextFrameworkPhaseName($route.params.routeName)"></arrow>
                </div>
            </div>
        </div>
        <div class="arrow" id="hideMe" v-if="scrollArrowVisible" @click="scrollToElement">
        </div>
    </div>
</template>


<script>
import Card from "../js/components/Card.vue";
import InformationLetter from "../js/components/InformationLetter.vue";
import InformationLetterList from "../js/components/InformationLetterList.vue";
import InformationVisualisation from "../js/components/InformationVisualisation.vue";
import Score from "../js/components/Score.vue";
import HorizontalNav from '../js/components/HorizontalNav.vue';
import Arrow from '../js/components/Arrow.vue';
import InfLetterCard from '../js/components/InfLetterCard.vue';
import Vue from "vue";
import axios from "axios";

export default { 
    name: "App",
    components: {
        InformationLetter,
        InformationLetterList,
        Card,
        Score,
        InformationVisualisation,
        HorizontalNav,
        Arrow,
        InfLetterCard
    },
    props: {
        phases: []
        },
    data: function() {
        return {
            phase: [],
            informationLetters: [],
            recommendations: [],
            weakPoints: [],
            avgScores: null,
            maturityLevel: null,
            previousRouteName: "",
            isFrameworkCondition: false,
            displayName: "",
            FirstinformationLetter: null,
            informationLetterArray: [],
            questionToRecommendationId: {},
            recommendationTexts: [],
            wasNavigated: false,
            scrollArrowVisible: true,
        };
    },
    updated(){
        console.log("updated Phase");
        //important! - triggers if phases are changed -> MM - 2022-06-01
        if (this.$route.params.routeName != this.previousRouteName){
            this.wasNavigated = true;
            this.informationLetterArray = [];
            this.previousRouteName = this.$route.params.routeName;
            this.phase = this.getPhase(this.$route.params.routeName);
            if (this.isFrameworkCondition){
                this.displayName = this.phase.Name + " - Rahmenbedingungen"; 
            }
            else {
                this.displayName = this.phase.Name;
            }
            this.fetchMaturityLevel(); // -> causes an update of Phase.vue - MM - 2022-06-01
            this.fetchRecommendations();
        }
    },
    mounted(){
        console.log("mounted Phase");
        window.addEventListener('scroll', this.handleScroll);
    },
    //runs automatically when the page loads...
    created() {
        console.log("created Phase");
        //this.fetchWeakPoints();
        //this.fetchAvgScores();
        this.phase = this.getPhase(this.$route.params.routeName);
        //this.fetchInformationLetters();
        this.fetchMaturityLevel();
        this.fetchRecommendations();
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        scrollToElement() {
            const el = this.$refs.infLetter;
            this.scrollArrowVisible = false;
            if (el) {
            // Use el.scrollIntoView() to instantly scroll to the element
            el.scrollIntoView({behavior: 'smooth'});
            }
        },
        handleScroll(event){
            this.scrollArrowVisible = false;
        },
        //returns name of the phase based on routing id
        getPhase(routeName){
            //Filter out framework string
            if (routeName.indexOf('framework') > -1){
                routeName = routeName.substring(0, routeName.indexOf('framework')-1);
                this.isFrameworkCondition = true;
            }
            else{
                this.isFrameworkCondition = false;
            }
            return this.phases.find(phase => (phase.route === routeName));
            //return this.$parent.phases.find(phase => (phase.route === routeName)); //bug
        },
        getThisPhaseRoute(curRoute) {
            if (curRoute.indexOf('framework') > -1){
                curRoute = curRoute.substring(0, curRoute.indexOf('framework')-1);
            }
            for (let i = 0; i < this.phases.length; i++) {
                if (
                    this.phases[i].route === curRoute
                ) {
                    return "/result/phase/" + this.phases[i].route;
                }
            }
        },
        getThisPhaseName(curRoute) {
            if (curRoute.indexOf('framework') > -1){
                curRoute = curRoute.substring(0, curRoute.indexOf('framework')-1);
            }
            for (let i = 0; i < this.phases.length; i++) {
                if (
                    this.phases[i].route === curRoute
                ) {
                    return this.phases[i].Name;
                }
            }
        },
        //returns route to the next phase
        getNextPhaseRoute(curRoute) {
            if (curRoute === "qm-core-tools") return "/result/overview";
            for (let i = 0; i < this.phases.length; i++) {
                if (
                    this.phases[i].route === curRoute &&
                    i + 1 <= this.phases.length
                ) {
                    if (this.phases[i + 1].route) {
                        return "/result/phase/" + this.phases[i + 1].route;
                    }
                }
            }
        },
        getNextPhaseId(curRoute) {
            if (curRoute === this.phases[phases.length - 1].route) return "0";
            for (let i = 0; i < this.phases.length; i++) {
                if (
                    this.phases[i].route === curRoute &&
                    i + 1 <= this.phases.length
                ) {
                    if (this.phases[i + 1].Id) {
                        return this.phases[i + 1].Id;
                    }
                }
            }
        },
        getNextPhaseName(curRoute) {
            if (curRoute === "qm-core-tools") return "Übersicht";
            for (let i = 0; i < this.phases.length; i++) {
                if (
                    this.phases[i].route === curRoute &&
                    i + 1 <= this.phases.length
                ) {
                    if (this.phases[i + 1].Name) {
                        return this.phases[i + 1].Name;
                    }
                }
            }
        },
        getNextFrameworkPhaseRoute(curRoute) {
            if (curRoute.indexOf('framework') > -1){
                curRoute = curRoute.substring(0, curRoute.indexOf('framework')-1);
            }
            if (curRoute === "qm-core-tools") return "/result/overview";
            for (let i = 0; i < this.phases.length; i++) {
                if (
                    this.phases[i].route === curRoute &&
                    i + 1 <= this.phases.length
                ) {
                    if (this.phases[i + 1].route) {
                        return "/result/phase/" + this.phases[i + 1].route;
                    }
                }
            }
        },
        getNextFrameworkPhaseId(curRoute) {
            if (curRoute.indexOf('framework') > -1){
                curRoute = curRoute.substring(0, curRoute.indexOf('framework')-1);
            }
            if (curRoute === this.phases[phases.length - 1].route) return "0";
            for (let i = 0; i < this.phases.length; i++) {
                if (
                    this.phases[i].route === curRoute &&
                    i + 1 <= this.phases.length
                ) {
                    if (this.phases[i + 1].Id) {
                        return this.phases[i + 1].Id;
                    }
                }
            }
        },
        getNextFrameworkPhaseName(curRoute) {
            if (curRoute.indexOf('framework') > -1){
                curRoute = curRoute.substring(0, curRoute.indexOf('framework')-1);
            }
            if (curRoute === "qm-core-tools") return "Übersicht";
            for (let i = 0; i < this.phases.length; i++) {
                if (
                    this.phases[i].route === curRoute &&
                    i + 1 <= this.phases.length
                ) {
                    if (this.phases[i + 1].Name) {
                        return this.phases[i + 1].Name;
                    }
                }
            }
        },
        getPrevPhaseName(curRoute) {
            if (curRoute === this.phases[0].route) return "Übersicht";
            for (let i = 0; i < this.phases.length; i++) {
                if (this.phases[i].route === curRoute && i - 1 >= 0) {
                    if (this.phases[i - 1].Name) {
                        return this.phases[i - 1].Name;
                    }
                }
            }
        },
        //returns route to the previous phase
        getPrevPhaseRoute(curRoute) {
            if (curRoute === this.phases[0].route) return "/result/overview";
            for (let i = 0; i < this.phases.length; i++) {
                if (this.phases[i].route === curRoute && i - 1 >= 0) {
                    if (this.phases[i - 1].route) {
                        return "/result/phase/" + this.phases[i - 1].route;
                    }
                }
            }
        },
        getPrevPhaseId(curRoute) {
            if (curRoute === "planning-and-conception") return "0";
            for (let i = 0; i < this.phases.length; i++) {
                if (this.phases[i].route === curRoute && i - 1 >= 0) {
                    if (this.phases[i - 1].Id) {
                        return this.phases[i - 1].Id;
                    }
                }
            }
        },
        //get the InformationLetters of the current user...
        fetchInformationLetters() {
           
        },
        findRecommendations(){
            //Filters recommendations based on the OVERALL Average Maturity Level
            //MAY BE SUBJECT TO CHANGE
            let recommendationsForMaturityLevel = [];
            let recommendationTextsTmp = []; 
            let recommendationToRecommendationId = {};
            recommendationsForMaturityLevel = this.recommendations.filter(point => (point.MaturityLevelValue <= this.maturityLevel));
            for (let recommendation of recommendationsForMaturityLevel) {
               // recommendationToRecommendationId[recommendation.RecommendationText] = recommendation.RecommendationId
                recommendationTextsTmp.push(recommendation.QuestionName + ": " +recommendation.RecommendationText);
                if (this.questionToRecommendationId[recommendation.QuestionName] !== undefined) 
                {
                    this.questionToRecommendationId[recommendation.QuestionName].push(recommendation.RecommendationId);
                } 
                else 
                {
                    this.questionToRecommendationId[recommendation.QuestionName] = [ recommendation.RecommendationId ];
                }
            }
            return recommendationTextsTmp;
        },
        //Function fetches recommendations AND information letters at once as IL are dependend on recommendations
        fetchRecommendations(){
            let vm = this;
            let isFrameworkCondition = null;
            this.informationLetters = [];
            let axiosCalls = [];
            if(this.$route.params.routeName.indexOf("framework") > -1)
            {
                isFrameworkCondition = 1;
            }
            else
            {
                isFrameworkCondition = 0;
            }
            console.log("Fetching Recommendations");
            const curPhase = JSON.parse(JSON.stringify(this.phase));
            axios
                .get("/api/recommendationsByPhaseByUser/" + this.phase.Id + "/" + isFrameworkCondition)
                .then(response => {
                    
                    this.recommendations = response.data;
                    console.log(this.recommendations);
                    this.recommendationTexts = this.findRecommendations();
                    this.recommendations.forEach(element => {
                        let name = element.QuestionName;
                        if(this.questionToRecommendationId[name] === undefined){
                            return;
                        }
                        let call = "/api/informationLettersByRecommendation/" + element.RecommendationId;
                        const callFunction = axios.get(call);
                        axiosCalls.push(callFunction);

                    })
                    //console.log("Axios Calls: " + axiosCalls);
                    axios.all(axiosCalls)
                        .then(axios.spread((...responses) => {
                            responses.forEach(element => {
                                for (let i = 0; i<element.data.length; i++)
                                    this.informationLetterArray.push([element.data[i], curPhase]);
                            })
                            
                            this.wasNavigated = false;
                            //console.log(this.informationLetterArray[0]);
                            //Filter doubles in informationLetterArray
                            //Filtering done based on name because objects are not properly filtered by faster filter function
                            for (let element of this.informationLetterArray) {
                                let included = false;
                                for (let letter of this.informationLetters) {
                                    if (element[0].Id === letter.Id){
                                        included = true;
                                        //stores different RecommendationIds in letter-objects
                                        if (typeof letter.pivot['RecommendationId'] === "string") {
                                            let a = element[0].pivot['RecommendationId'];
                                            let b = letter.pivot['RecommendationId'];
                                            letter.pivot['RecommendationId'] = [a, b];
                                        } else {
                                            let a = letter.pivot['RecommendationId'];
                                            a.push(element[0].pivot['RecommendationId']);
                                        }
                                        break;
                                    }
                                }
                                //Case we dont switch the
                                if (!included && ((element[1].Id == this.phase.Id))) {
                                    this.informationLetters.push(element[0]);
                                }
                            }
                            this.informationLetterArray = []; //Delete old informationLetters so they dont accumulate
                            //console.log("InformationLetters:" + this.informationLetters);
                            }))
                        .catch(err => console.log(err));
                })
                .catch(err => console.log(err));
        },
        async fetchWeakPoints(){
            this.weakPoints = [
                {
                    id: 1,
                    points: ["Machine Learning", "Digital Engineering"]
                },
                {
                    id: 2,
                    points: ["Anforderungsmanagment"]
                },
                {
                    id: 3,
                    points: [
                        "Digitale Fabrik",
                        "Smart Engineering",
                        "CAQ Software",
                        "Software für Variationen",
                        "Digilate Anweisungen"
                    ]
                },
                {
                    id: 4,
                    points: ["Digitale Zwillinge", "Utility Films"]
                },
                {
                    id: 5,
                    points: ["Lager"]
                },
                {
                    id: 6,
                    points: ["PPS", "MES"]
                },
                {
                    id: 7,
                    points: [
                        "Track & Trace",
                        "Condition Monitoring",
                        "Track & Trace"
                    ]
                },
                {
                    id: 8,
                    points: ["Machine Learning", "Digital Engineering"]
                },
                {
                    id: 9,
                    points: ["Anforderungsmanagment"]
                }
            ]
        },
        fetchAvgScores(){
            this.avgScores = [2.6, 2.42, 1.79, 2.23, 1.87, 1.58, 1.5, 2.6, 2.42];
        },
        fetchMaturityLevel() {
            let vm = this;
            let isFrameworkCondition = null;

            if(this.$route.params.routeName.indexOf("framework") > -1)
            {
                isFrameworkCondition = 1;
            }
            else
            {
                isFrameworkCondition = 0;
            }

            axios
                .get("/api/maturityLevelByPhase/" + this.phase.Id + "/" + isFrameworkCondition) //HIER ERGÄNZEN
                .then(response => {
                    var doubleMaturityLevel = response.data[0].AvgMaturityLevelValue;                    
                    var stringMaturityLevel = doubleMaturityLevel + '';                    
                    if(stringMaturityLevel[0] == '.')
                    {
                        stringMaturityLevel = '0' + stringMaturityLevel;
                    }
                    this.maturityLevel = stringMaturityLevel;                    
                })
                .catch(err => console.log(err)); 
            return this.maturityLevel;
        }
    }
};
</script>
<style>
    html {
        scroll-behavior: smooth;
    }
    
</style>
